import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '@app/shared/services/api/api.service';
import { assign } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class AddressSearchService extends ApiService {
  constructor(public http: HttpClient) {
    super(http);
  }

  public search(searchText: string, query: any = {}): Observable<any> {
    const queryString = assign(
      {
        language: 'de',
        country: 'de',
        fuzzyMatch: false,
      },
      query,
    );
    return this.http.get<any>(`/map-search/geocoding/v5/mapbox.places/${encodeURI(searchText)}`, { params: queryString });
  }

  public suggest = (searchString: string, municipalityKey: string, count = 5) => {
    return this.http.get<any[]>(
      `/map-webatlas-search/suggest?query=${searchString ? encodeURI(searchString) : '""'}&filter=ags:${municipalityKey}&count=${count}`,
    );
  };

  public searchByPostCode = (searchString: string, postCode: string, count = 1) => {
    return this.http.get<any[]>(`/map-webatlas-search/geosearch?query=${searchString ? encodeURI(searchString) : '""'}&filter=plz:${postCode}&count=${count}`);
  };

  public searchBy = (searchString: string, municipalityKey: string, count = 1) =>
    this.http.get<any[]>(`/map-webatlas-search/geosearch?query=${searchString ? encodeURI(searchString) : '""'}&filter=ags:${municipalityKey}&count=${count}`);

  public webatlasSearch = (searchString: string, count = 1) =>
    this.http.get<any[]>(`/map-webatlas-search/geosearch?query=${searchString ? encodeURI(searchString) : '""'}&count=${count}`);

  public searchByMunicipalityKey = (municipalityKey: string, searchString = '', count = 1) =>
    this.http.get<any>(`/map-webatlas-search/geosearch?query=${searchString ? encodeURI(searchString) : '""'}&filter=ags:${municipalityKey}&count=${count}`);

  public searchByMunicipality = (municipality: any) => {
    return this.searchByMunicipalityKey(municipality.key);
  };
}
